import React from 'react';
import '@assets/sass/components/buttons/link-button.scss';

export default ({ href, content }) => {
    return <a target="_blank" href={href} className="link-button">{content}</a>
}